import {Fragment, FC} from 'react';
import HappyCloseIcon from '@stencil/icons/src/HappyCloseIcon/HappyCloseIcon';
import {defaultTheme} from '@stencil/build-theme';
import * as S from './CkiTimePopup.styles';
import {FlexCentered} from './generic.styles';

const daySunsetImage = 'https://gos3.ibcdn.com/meal-1636355029.png';

const proceedText = 'Proceed';
const cancelText = 'No, Select different room';

interface CkiTimePopupProps {
  isPWA?: boolean;
  onProceed: () => void;
  onCancel: () => void;
  dayUsePrams: {
    h: string;
    msg: string;
    pmsg: string;
  };
}

const CkiTimePopup: FC<CkiTimePopupProps> = ({isPWA, onProceed, onCancel, dayUsePrams}) => {
  const {h, msg, pmsg} = dayUsePrams;
  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <S.ModalSelectWrapperUI isPWA={isPWA}>
      <S.Header_Wrapper isPWA={isPWA}>
        {isPWA ? (
          <>
            <S.Circular_WhiteWrap>
              <S.SunSet_Image isPWA={isPWA} src={daySunsetImage} />
            </S.Circular_WhiteWrap>
            <S.HeaderBoldTextPara isPWA={isPWA}>{h}</S.HeaderBoldTextPara>
          </>
        ) : (
          <FlexCentered>
            <S.SunSet_Image isPWA={isPWA} src={daySunsetImage} />
            <div>{h}</div>
          </FlexCentered>
        )}
        {!isPWA ? (
          <HappyCloseIcon
            height="2rem"
            width="2rem"
            fill={defaultTheme.colors.downriver.base}
            onClick={onCancel}
          />
        ) : null}
      </S.Header_Wrapper>
      <S.Middle_ContentWrap isPWA={isPWA}>
        <S.Text_Para isPWA={isPWA}>{msg}</S.Text_Para>
        <S.Bold_Text_Para isPWA={isPWA}>{pmsg}</S.Bold_Text_Para>
      </S.Middle_ContentWrap>
      <S.Bottom_ContentWrap isPWA={isPWA}>
        <S.DifferentRoom_Link isPWA={isPWA} onClick={onCancel}>
          {cancelText}
        </S.DifferentRoom_Link>
        <S.Proceed_Btn isPWA={isPWA} onClick={onProceed}>
          {proceedText}
        </S.Proceed_Btn>
      </S.Bottom_ContentWrap>
    </S.ModalSelectWrapperUI>
  );
};

export default CkiTimePopup;
